import React from 'react'
import { Route, Switch } from 'react-router-dom'

import CancellationOffersList from './cancellationOffersList'
import CreateEditCancellationOffer from './createEditOffer'

import { routePrefix } from '../../config';

import './styles.css'
import { opdbGTM } from '../../utils/pulseUtils';

class CancellationContainer extends React.Component {

  componentDidMount() {
    document.title = 'Cancellation Offers';
    opdbGTM.tabClicked('od_free_cancellation_tab_clicked');
  }

  render() {
    return (
      <Switch>
        <Route exact path={routePrefix + '/cancellation-offer/create'} component={CreateEditCancellationOffer} />
        <Route exact path={routePrefix + '/cancellation-offer/edit/:id/:paytmRoute'} component={CreateEditCancellationOffer} />
        <Route path={routePrefix + '/cancellation-offer'} component={CancellationOffersList} />
      </Switch>
    )
  }
}

CancellationContainer.propTypes = {}

export default (CancellationContainer)
